import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "expanded", "children", "detailStyle", "headerStyle", "fullWidth", "iconProps", "onClick", "onChange", "onContextMenu", "hideIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PT from 'prop-types';
import { iconPropTypes } from '@scaleflex/icons/icon.prop-types';
import { intrinsicComponent } from '../../utils/functions';
import AccordionHeader from '../accordion-header';
import AccordionDetails from '../accordion-details';
import Styled from './accordion.styles';
var Accordion = intrinsicComponent(function (_ref, ref) {
  var label = _ref.label,
    expanded = _ref.expanded,
    children = _ref.children,
    detailStyle = _ref.detailStyle,
    headerStyle = _ref.headerStyle,
    fullWidth = _ref.fullWidth,
    iconPropsData = _ref.iconProps,
    _onClick = _ref.onClick,
    onChange = _ref.onChange,
    onContextMenu = _ref.onContextMenu,
    hideIcon = _ref.hideIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.Accordion, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(AccordionHeader, {
    label: label,
    expanded: expanded,
    style: _objectSpread({}, headerStyle),
    hideIcon: hideIcon,
    onClick: function onClick(event) {
      if (typeof onChange === 'function') {
        onChange(!expanded, event);
      }
      if (typeof _onClick === 'function') {
        _onClick(event);
      }
    },
    onContextMenu: onContextMenu,
    iconProps: iconPropsData,
    fullWidth: fullWidth
  }), /*#__PURE__*/React.createElement(AccordionDetails, {
    expanded: expanded,
    style: _objectSpread({}, detailStyle)
  }, children));
});
Accordion.defaultProps = {
  expanded: false,
  hideIcon: false
};
Accordion.propTypes = {
  label: PT.node.isRequired,
  expanded: PT.bool,
  detailStyle: PT.object,
  headerStyle: PT.object,
  onChange: PT.func,
  onContextMenu: PT.func,
  hideIcon: PT.bool,
  fullWidth: PT.bool,
  iconProps: PT.exact(iconPropTypes)
};
export default Accordion;